import { useMemo } from "react";
import { Grid, IconButton, TablePagination } from "@mzc-pdc/ui";
import { IconRefresh } from "@mzc-cloudplex/icons";
import { useTranslation } from "react-i18next";

export const Pagination = (props) => {
    const {
        totalCount,
        page,
        limit,
        limitOptions,
        onChangePage,
        onChangeLimit,
        onClickRefresh,
        hiddenPagination = false,
    } = props;

    const { t } = useTranslation();

    const rowsPerPageOptions = useMemo(() => {
        if (!limit) return [];
        const options = limitOptions ?? [10, 20, 50, 100, 150, 200];
        return options.map((option) => ({
            label: t(`common::label::${option} views`, `${option} views`),
            value: option,
        }));
    }, [limitOptions, t, limit]);

    const getNextButtonDisabled = () => {
        const hasNextTokenProvided = "hasNextToken" in props;
        const hasNextToken = props.hasNextToken;

        if (hasNextTokenProvided) {
            return !hasNextToken;
        } else {
            return totalCount ? totalCount <= (page + 1) * limit : true;
        }
    };

    return (
        <Grid container flexDirection={"row"} sx={{ ...(hiddenPagination ? { gap: 0.75 } : {}) }}>
            <IconButton circled variant={"text"} color={"inherit"} size={`medium`} onClick={onClickRefresh}>
                <IconRefresh size={16} />
            </IconButton>
            <TablePagination
                SelectProps={{
                    size: `small`,
                }}
                component={"div"}
                count={totalCount ?? 0}
                page={page ?? 0}
                onPageChange={(event, page) => {
                    onChangePage(page);
                }}
                labelDisplayedRows={({ from, to, count }) => {
                    if (!count) return "";
                    return isNaN(to) ? "" : `${from}-${to} ${count ? `of ${count}` : ""}`;
                }}
                labelRowsPerPage={""}
                rowsPerPage={limit}
                onRowsPerPageChange={(event) => onChangeLimit(parseInt(event.target.value, 10))}
                rowsPerPageOptions={rowsPerPageOptions}
                nextIconButtonProps={{ disabled: getNextButtonDisabled() }}
                sx={{ ...(hiddenPagination ? { ".MuiTablePagination-actions": { display: "none" } } : {}) }}
            />
        </Grid>
    );
};
